module.exports = __webpack_public_path__ + "media/components/incentive/static/speed-91daf1958b9eb9f349f8e3db7d703363.svg";